import { useEffect, useRef, useState } from 'react';

interface UseModalBehaviorProps {
    isOpen: boolean;
    nonDismissible: boolean;
    onClose?: () => void;
}

export const useModalBehavior = ({ isOpen, nonDismissible, onClose }: UseModalBehaviorProps) => {
    const [modalBumpAnimation, setModalBumpAnimation] = useState(false);
    const modalRef = useRef<HTMLDivElement>(null);

    const bumpAnimateOverlay = () => {
        setModalBumpAnimation(true);
        setTimeout(() => setModalBumpAnimation(false), 200);
    };

    // Focus on modal when opened
    useEffect(() => {
        if (isOpen && modalRef.current) {
            modalRef.current.focus();
        }
    }, [isOpen]);

    // Handle ESC key to close modal
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                if (nonDismissible) {
                    bumpAnimateOverlay();
                } else {
                    onClose?.();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, nonDismissible, onClose]);

    return {
        modalRef,
        modalBumpAnimation,
        bumpAnimateOverlay,
    };
};
